import { render, staticRenderFns } from "./Orangedot.vue?vue&type=template&id=653d5a5f&scoped=true&"
import script from "./Orangedot.vue?vue&type=script&lang=js&"
export * from "./Orangedot.vue?vue&type=script&lang=js&"
import style0 from "./Orangedot.vue?vue&type=style&index=0&id=653d5a5f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653d5a5f",
  null
  
)

export default component.exports